import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PawTrail } from './PawTrail';
export function ClosingSection() {
  return <section id="cierre" className="relative overflow-hidden bg-cream py-16 sm:py-20" data-id="element-17" data-mp="12su0hpdvgyda">
      <PawTrail count={4} className="absolute bottom-10 right-[7%] hidden lg:flex" tone="gold" data-id="element-18" data-mp="12qh96lm85bnk" />

      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-19" data-mp="xvv5l4mdwne1">
        <h2 className="font-display text-3xl font-semibold leading-[1.1] tracking-tight text-petrol sm:text-[2.75rem]" data-id="element-20" data-mp="1cpq8zv3rtkhu">
          Tu próximo paso puede empezar hoy. 🐾
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-sans text-lg leading-relaxed text-petrol/75" data-id="element-21" data-mp="1lia2kh57gyvt">
          Aprendé, armá tu servicio y empezá a organizar tu propio trabajo con perros desde una sola
          app.
        </p>
        <CtaButton size="lg" className="mt-8 w-full sm:w-auto sm:!px-12" data-id="element-22" data-mp="1vi0wohputbvd">
          Quiero empezar
          <ArrowRightIcon className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" data-id="element-23" data-mp="1qjzhw8zgnypp" />
        </CtaButton>
      </div>
    </section>;
}